import React, { useEffect, useMemo, useState } from 'react'
import { Box } from '@mui/material'
import { useLocation, useNavigate } from 'react-router-dom'
import { PlugIntelligenceClient } from '@plug-core/clients/PlugIntelligenceClient'
import Touchable from '@components/Touchable'
import { ROUTES } from '@utils/routes'
import { AnimationPlayer } from '@components/AnimationPlayer'
import pIAnimation from '@assets/lottie/plug-intelligence.json'

export const LLMChatButton = () => {
  const [isAvailable, setIsAvailable] = useState(false)

  const { pathname } = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    if (pathname === ROUTES.HOME) {
      PlugIntelligenceClient.isAvailable().then(setIsAvailable)
    }
  }, [])

  if (!isAvailable) return null

  return (
    <Box position="absolute" zIndex={4} bottom={60} right={24}>
      <Touchable
        onClick={() => navigate(ROUTES.LLM_CHAT)}
        scaleFactor={0.15}
        style={{
          width: 48,
          height: 48,
          borderRadius: 14,
          background:
            'linear-gradient(107deg, rgba(30,33,105,1) 0%, rgba(68,50,140,1) 50%, rgba(28,15,80,1) 100%)',
          opacity: 0.92,
          overflow: 'hidden',
        }}
      >
        <Box width="115px" top="-16px" left="-33px" position="absolute">
          <AnimationPlayer animationData={pIAnimation} />
        </Box>
      </Touchable>
    </Box>
  )
}
